import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_d00c02dc/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/tmp/build_d00c02dc/layouts/login.vue").then(m => m.default || m))
}